import './style/QuickOverlayLayers.css';

const QuickOverlayLayers = ({
  checkedLayers,
  handleCheckboxEvent,
  loadingLayers,
}) => {
  const layerName = 'Perfilamento a LASER Aerotransportado';
  const isChecked = checkedLayers[layerName] || false;
  const isLoading = loadingLayers[layerName] || false;

  return (
    <div className="quick-overlay">
      <ul className="quick-overlay-lista">
        <li>
          <label className="quick-overlay-label-base">
            <input
              type="checkbox"
              className="quick-overlay-checkbox-base"
              checked={isChecked}
              disabled={isLoading}
              onChange={(e) => handleCheckboxEvent(e, layerName)}
            />
            Faixas de Voo Laser
          </label>
        </li>
      </ul>
    </div>
  );
};

export default QuickOverlayLayers;
